import { DataProxy } from '@apollo/client'
import { ClientOrCache } from '@sketch/graphql-cache'

const errorPreventiveFragmentRead = <Query = any, Variables = any>(
  cache: ClientOrCache,
  readOptions: DataProxy.Fragment<Variables, Query>
) => {
  try {
    return cache.readFragment<Query, Variables>(readOptions)
  } catch (e) {
    return null
  }
}

export default errorPreventiveFragmentRead
